var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择轮毂高度",
        visible: _vm.visible,
        width: "20%",
        "before-close": _vm.handleCancel
      }
    },
    [
      _c(
        "span",
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择" },
              model: {
                value: _vm.hubHeight,
                callback: function($$v) {
                  _vm.hubHeight = $$v
                },
                expression: "hubHeight"
              }
            },
            _vm._l(_vm.hubHeights, function(item) {
              return _c("el-option", {
                key: item,
                attrs: { label: item, value: item }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取 消")
          ]),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.hubHeight, type: "primary" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }